var name = {};
module['exports'] = name;
name.first_name = require("./first_name");
name.last_name = require("./last_name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nep/name/index.js
// module id = 931
// module chunks = 0